module.exports = __webpack_public_path__ + "images/category_lp/art_work/new/assessment_achievements/1@2x_3febefe17b419ebc898656f72819b6a8.png";